import React, { useState, useCallback } from "react";
import { RendererProps } from "./index";
import { CheckboxGrid, ChoiceOption } from "./renderer-styles";

const MultiCheckboxRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const [checked, setChecked] = useState<Record<string, boolean>>(() => {
    if (answer?.values?.[0] && typeof answer.values[0] === "object") {
      return answer.values[0] as Record<string, boolean>;
    }
    return {};
  });

  const handleToggle = useCallback(
    (value: string) => {
      setChecked((prev) => {
        const next = { ...prev, [value]: !prev[value] };
        const anyChecked = Object.values(next).some(Boolean);
        onAnswer(null, anyChecked, [next]);
        return next;
      });
    },
    [onAnswer]
  );

  return (
    <CheckboxGrid>
      {(question.choices || []).map((choice) => (
        <ChoiceOption key={choice.value} selected={!!checked[choice.value]}>
          <input
            type="checkbox"
            value={choice.value}
            checked={!!checked[choice.value]}
            onChange={() => handleToggle(choice.value)}
          />
          {choice.title || choice.label}
        </ChoiceOption>
      ))}
    </CheckboxGrid>
  );
};

export default MultiCheckboxRenderer;
